export async function loadAstroguide() {
  const url = `${import.meta.env.BASE_URL}data/astroguide.min.json`;
  const response = await fetch(url, { cache: 'force-cache' });
  if (!response.ok) throw new Error(`Astroguide load failed: ${response.status}`);
  const data = await response.json();
  return Array.isArray(data) ? data : [];
}

export function elementLabel(element, lang = 'ko') {
  const ko = { fire: '불', water: '물', tree: '나무', wood: '나무', light: '빛', dark: '어둠' };
  const en = { fire: 'Fire', water: 'Water', tree: 'Wood', wood: 'Wood', light: 'Light', dark: 'Dark' };
  const key = String(element || '').toLowerCase();
  return (lang === 'en' ? en : ko)[key] || element || '-';
}

export function monsterDisplayName(monster, lang = 'ko') {
  if (!monster) return '-';
  return lang === 'en' ? (monster.name || monster.name_kor || '-') : (monster.name_kor || monster.name || '-');
}

export function findMonsterForEquipped(gems, astro, equippedLabel) {
  const uid = gems.find((g) => g.equipped_monster_uid != null)?.equipped_monster_uid;
  if (uid != null) {
    const exact = astro.find((m) => String(m.uid) === String(uid));
    if (exact) return exact;
  }
  const clean = String(equippedLabel || '').replace(/<[^>]+>/g, '').replace(/\s*\(\d+\)\s*$/, '').trim();
  return astro.find((m) => m.name_kor === clean || m.name === clean)
    || astro.find((m) => String(m.name_kor || '').includes(clean))
    || null;
}
